import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import "./BillingSuccess.css";

export default function BillingSuccess() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const sessionId = searchParams.get("session_id");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");


    useEffect(() => {

        if (!sessionId) {

            setError(
                "Missing Stripe checkout session."
            );

            setLoading(false);

            return;
        }


        const verifyCheckout = async () => {

            try {

                const response = await fetch(
                    `/api/stripe/checkout-session/${encodeURIComponent(
                        sessionId
                    )}`,
                    {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Accept": "application/json"
                        }
                    }
                );


                const data = await response.json();


                if (!response.ok) {

                    throw new Error(
                        data.message ||
                        "Unable to verify your subscription."
                    );
                }


                setLoading(false);

            } catch (err) {

                console.error(
                    "Checkout verification error:",
                    err
                );

                setError(
                    err.message ||
                    "Unable to verify your subscription."
                );

                setLoading(false);
            }
        };


        verifyCheckout();

    }, [sessionId]);


    /* =====================================================
       LOADING
    ===================================================== */

    if (loading) {

        return (

            <div className="billing-success-page">

                <div className="billing-success-card">

                    <div className="billing-success-spinner"></div>

                    <h1>
                        Confirming your subscription...
                    </h1>

                    <p className="billing-success-subtitle">
                        Please wait while we activate your
                        STEMX365 account.
                    </p>

                </div>

            </div>
        );
    }


    /* =====================================================
       ERROR
    ===================================================== */

    if (error) {

        return (

            <div className="billing-success-page">

                <div className="billing-success-card">

                    <div className="billing-success-icon error">
                        !
                    </div>

                    <h1>
                        We couldn't verify your payment
                    </h1>

                    <p className="billing-success-subtitle">
                        Your payment may have succeeded,
                        but we could not verify the
                        subscription yet.
                    </p>

                    <div className="billing-success-error">
                        {error}
                    </div>

                    <div className="billing-success-actions">

                        <button
                            type="button"
                            className="billing-success-button"
                            onClick={() =>
                                navigate(
                                    "/rect/app/labs/pricing"
                                )
                            }
                        >
                            Back to Pricing
                        </button>

                    </div>

                </div>

            </div>
        );
    }


    /* =====================================================
       SUCCESS
    ===================================================== */

    return (

        <div className="billing-success-page">

            <div className="billing-success-card">

                {/* SUCCESS ICON */}

                <div className="billing-success-icon">
                    ✓
                </div>


                {/* TITLE */}

                <h1>
                    You're all set!
                </h1>


                {/* SUBTITLE */}

                <p className="billing-success-subtitle">
                    Your STEMX365 subscription is active.
                </p>


                {/* DESCRIPTION */}

                <p className="billing-success-description">
                    Your robotics laboratory is ready
                    to be created.
                </p>


                {/* BUTTON */}

                <div className="billing-success-actions">

                    <button
                        type="button"
                        className="billing-success-button"
                        onClick={() =>
                            navigate(
                                "/rect/profile"
                            )
                        }
                    >
                        Start Building
                    </button>

                </div>


                {/* BRAND */}

                <div className="billing-success-brand">

                    <strong>
                        STEMX365
                    </strong>

                    <span>
                        {" "}·{" "}
                    </span>

                    Space Robotics Cloud

                </div>

            </div>

        </div>
    );
}